import {
  GET_CURRENT_SCHEDULE,
  GET_CURRENT_SCHEDULE_ERROR,
  GET_CURRENT_SCHEDULE_NO_LOAD,
  GET_APPOINTMENT,
  GET_APPOINTMENT_SUCCESS,
  GET_APPOINTMENT_ERROR,
  GET_APPOINTMENT_NO_LOAD,
  GET_PATIENT,
  GET_PATIENT_SUCCESS,
  GET_PATIENT_ERROR,
  GET_PATIENT_NO_LOAD,
  GET_SCHEDULE_BY_ID,
  GET_SCHEDULE_BY_ID_ERROR,
  EDIT_SCHEDULE,
  EDIT_SCHEDULE_ERROR,
  ADD_TO_SCHEDULE,
  ADD_TO_SCHEDULE_ERROR,
  SET_ERROR,
  SET_IS_APPOINTMENT_POPUP_SHOWN,
  SET_LOADING,
  SET_IS_SUCCESS_SCHEDULE_EDIT,
  RESET_SCHEDULE_RECURRING_INFO,
} from '../calendar/CalendarConstants'

export const calendarReducerBlackListActions = [
  GET_CURRENT_SCHEDULE,
  GET_CURRENT_SCHEDULE_ERROR,
  GET_CURRENT_SCHEDULE_NO_LOAD,
  GET_APPOINTMENT,
  GET_APPOINTMENT_SUCCESS,
  GET_APPOINTMENT_ERROR,
  GET_APPOINTMENT_NO_LOAD,
  GET_PATIENT,
  GET_PATIENT_SUCCESS,
  GET_PATIENT_ERROR,
  GET_PATIENT_NO_LOAD,
  GET_SCHEDULE_BY_ID,
  GET_SCHEDULE_BY_ID_ERROR,
  EDIT_SCHEDULE,
  EDIT_SCHEDULE_ERROR,
  ADD_TO_SCHEDULE,
  ADD_TO_SCHEDULE_ERROR,
  SET_ERROR,
  SET_IS_APPOINTMENT_POPUP_SHOWN,
  SET_LOADING,
  SET_IS_SUCCESS_SCHEDULE_EDIT,
  RESET_SCHEDULE_RECURRING_INFO,
]
